import React from "react";

import clsx from "clsx";

import { CheckIcon } from "@heroicons/react/outline";

import HeaderCell from "./headerCell";
import styles from "./index.module.css";
import { IntegrationFeature, IntegratorItem, RankedTableProps } from "./types";

type IntegratorCellsProps = { integrator: IntegratorItem; feature: IntegrationFeature; rank: number };
const IntegratorCells = ({ integrator, feature, rank }: IntegratorCellsProps) => {
  const integrationValue = feature.integrators?.find(i => i.item._ref === integrator._id);
  return (
    <div key={integrator._id} className={clsx(styles.mobileCellGroup, "group")}>
      <div className={clsx(styles.mobileCell, styles.mobileRankCell, "text-center w-14")}>#{rank}</div>
      <div className={clsx(styles.mobileIntegrationCell, "h-[45px]")}>
        <HeaderCell integrator={integrator} />
      </div>
      <div className={clsx(styles.mobileFeatureCell, "h-[45px] group-last:border-r-0")}>
        <div className={styles.integrationContent}>
          {!!integrationValue &&
            (integrationValue?.detail || (
              <div
                className="inline-block shadow-md bg-secondary p-1.5 rounded-full text-white"
                aria-label={`${integrator.name} Supported`}
              >
                <CheckIcon className="h-3 w-3 md:h-5 md:w-5" />
              </div>
            ))}
          {/* Placeholder to keep grid even */}
          {!integrationValue && <div className="flex-grow p-1.5 h-3 w-3 md:h-5 md:w-5" />}
        </div>
      </div>
    </div>
  );
};

const MobileChart = ({ integratorsList, features, title }: RankedTableProps) => (
  <div className="p-4 md:hidden space-y-8 rounded-b-lg shadow-md bg-white">
    {features.map((feature, index) => (
      <div key={feature._id || index}>
        <p>{feature.title}</p>
        <p className="text-gray-400 text-sm mt-1">{feature.description}</p>
        <div className="overflow-auto border border-gray-200 rounded-md mt-3">
          <div className={clsx(styles.mobileCellGroup, "group")}>
            <div className={clsx(styles.mobileRankCell, styles.mobileHeaderCell, "!text-[0.65rem] xs:!text-sm !px-2")}>
              Integration Rank
            </div>
            <div className={clsx(styles.mobileHeaderCell, styles.mobileIntegrationCell)}>{title}</div>
            <div className={clsx(styles.mobileHeaderCell, styles.mobileFeatureCell)}>Has Feature</div>
          </div>
          {integratorsList.map((integrator, integratorIndex) => (
            <IntegratorCells
              key={integrator._id || integratorIndex}
              integrator={integrator}
              feature={feature}
              rank={integratorIndex + 1}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default MobileChart;
